import { render } from "./stronaOgloszenia.vue?vue&type=template&id=340a57c6"
import script from "./stronaOgloszenia.vue?vue&type=script&lang=js"
export * from "./stronaOgloszenia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__